import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { useFeatureFlagContext } from '../feature-flags/FeatureFlagProvider';
import { resolveManagedRouteAccess } from './navigation';

export function RouteAccessBoundary({ children }: { children: ReactNode }) {
  const { role, isLoading } = useAuth();
  const { flags } = useFeatureFlagContext();
  const { pathname } = useLocation();

  if (isLoading) return null;
  if (!role) return <>{children}</>;
  if (resolveManagedRouteAccess(pathname, role, flags) === 'deny') {
    return <Navigate to="/403" replace />;
  }
  return <>{children}</>;
}
